import { useQuery } from '@tanstack/react-query';
import { apiClient } from 'src/libs/axios';
import { useAuth } from 'src/libs/rainbow';
import { userKeys } from './user-keys';
import { QueryOptions } from 'src/libs/react-query';

export interface GetAvailableWithdrawalBalanceResponse {
  availableAmount: number;
  pendingWithdrawals: {
    id: number;
    tokenID: string;
    amount: number;
    chainID: number;
    availableAt: string;
  }[];
  amount: number;
  availableAt: string;
  chainID: number;
  id: number;
  tokenID: string;
}

export type GetAvailableWithdrawableBalanceResponse = GetAvailableWithdrawalBalanceResponse[];

export const getAvailableWithdrawableBalance =
  async (): Promise<GetAvailableWithdrawableBalanceResponse> => {
    const response = await apiClient.get<GetAvailableWithdrawableBalanceResponse>(
      `/api/v2/signatures/balances/available-withdrawable`,
      {
        baseURL: process.env.REACT_APP_SIGNATURE_SERVICE_API_ENDPOINT,
      },
    );
    return response.data;
  };

export type UseGetAvailableWithdrawalBalanceOptions<TError, TContext> = QueryOptions<
  GetAvailableWithdrawableBalanceResponse,
  TError,
  GetAvailableWithdrawableBalanceResponse,
  ReturnType<typeof userKeys.allGetAvailableWithdrawalBalance>
>;

export const useGetAvailableWithdrawableBalance = <TError = Error, TContext = unknown>(
  options?: UseGetAvailableWithdrawalBalanceOptions<TError, TContext>,
) => {
  const { isAuthenticated, isEthereumWallet } = useAuth();
  return useQuery({
    queryKey: userKeys.allGetAvailableWithdrawalBalance(),
    queryFn: () => getAvailableWithdrawableBalance(),
    enabled: isAuthenticated && isEthereumWallet,
    ...options,
  });
};
